export function isIndexedDBSupport() {
  if (typeof window === 'undefined') {
    return false;
  }
  for (const property of [
    'indexedDB',
    'IDBDatabase',
    'IDBObjectStore',
    'IDBTransaction',
    'IDBIndex',
    'IDBCursor',
    'IDBKeyRange',
    'IDBRequest',
  ]) {
    if (!window.hasOwnProperty(property) || !(window as any)[property]) {
      return false;
    }
  }

  return true;
}
